<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        查看检测项目
      </h2>
      <div class="c-page__header-btns">
        <k-button
          v-if="canApplyModification"
          btn-text="申请修改"
          :auth-type="false"
          type="warning"
          icon="kestrel-icon ki-edit"
          @click="modificationVisible = true"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>
    <div class="l-page__body l-page--detail__body">
      <el-tabs
        v-model="activeTab"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
        @tab-click="handleTab"
      >
        <el-tab-pane
          label="项目信息"
          name="base"
        >
          <el-form
            :model="detail"
            :inline="true"
            label-position="right"
            label-width="150px"
            label-suffix="："
            class="c-form jx-jc-read-form"
          >
            <el-row class="c-form__row">
              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                基础信息
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="项目名称"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.xmmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="项目状态"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.xmztMc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="所属区域"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.areaMc || detail.qydm || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="项目地址"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.xmdz || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="项目概述"
                  class="c-form__item"
                >
                  <span class="c-form__read jx-jc-multiline">{{ detail.xmgs || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="委托单位"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.wtdw || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="统一社会信用代码"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.shxydm || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="联系人"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.lxr || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="联系电话"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.lxdh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="设计单位"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.sjdw || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="施工/维保单位"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.sgdw || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测日期"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayDate(detail.jcrqq) }} 至 {{ displayDate(detail.jcrqz) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="签到要求"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.qdyq === 'GPS' ? 'GPS签到' : (detail.qdyq || '-') }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="检测依据"
                  class="c-form__item"
                >
                  <span class="c-form__read jx-jc-multiline">{{ detail.jcyj || '-' }}</span>
                </el-form-item>
              </el-col>

              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                项目人员
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="项目负责人"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ memberNames('XMFZR') }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="审核人"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.shrMc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="现场检测员"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ memberNames('JCY') }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="批准人"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.pzrMc || '-' }}</span>
                </el-form-item>
              </el-col>

              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                设施系统
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="检测设施系统"
                  class="c-form__item"
                >
                  <el-checkbox-group
                    v-model="facilityCheckedIds"
                    disabled
                    class="jx-jc-facility-checks"
                  >
                    <el-checkbox
                      v-for="item in facilityOptions"
                      :key="item.ssxtxh"
                      :label="item.ssxtxh"
                    >
                      {{ item.ssxtbh }} {{ item.ssxtmc }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                合同信息
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="合同名称"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.htmc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="合同编号"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.htbh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="合同金额（元）"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ detail.htje == null ? '-' : detail.htje }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="合同有效期"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayDate(detail.htksrq) }} 至 {{ displayDate(detail.htjsrq) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="合同文件"
                  class="c-form__item"
                >
                  <el-link
                    v-if="detail.htfjid"
                    type="primary"
                    @click="downloadContract"
                  >
                    下载合同文件
                  </el-link><span
                    v-else
                    class="c-form__read"
                  >-</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane
          label="实施规划"
          name="plan"
          class="jx-jc-tab-plan"
        >
          <el-form
            :model="detail"
            :inline="true"
            label-position="right"
            label-width="120px"
            label-suffix="："
            class="c-form jx-jc-plan-form"
          >
            <el-row class="c-form__row">
              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                检测结论
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="检测结论说明"
                  class="c-form__item"
                >
                  <template v-if="conclusionEditing">
                    <el-input
                      v-model="conclusionDraft"
                      type="textarea"
                      :rows="5"
                      maxlength="3000"
                      show-word-limit
                      placeholder="请输入检测结论说明"
                    />
                    <div class="jx-jc-conclusion-actions">
                      <k-button
                        btn-text="保存"
                        :auth-type="false"
                        type="text"
                        icon="kestrel-icon ki-save"
                        @click="saveConclusion"
                      />
                      <k-button
                        btn-text="取消"
                        :auth-type="false"
                        type="text"
                        icon="kestrel-icon ki-close"
                        @click="cancelConclusion"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <span class="c-form__read jx-jc-multiline">{{ detail.jcjlsm || '-' }}</span>
                    <k-button
                      v-if="canEditConclusion"
                      btn-text="编辑"
                      :auth-type="false"
                      type="text"
                      icon="kestrel-icon ki-edit"
                      @click="editConclusion"
                    />
                  </template>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测结论"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ conclusionText(detail.jcjl) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测提醒"
                  class="c-form__item"
                >
                  <span class="c-form__read">检测项总计 <b class="u-text-primary">{{ itemSummary.totalCount || 0 }}</b> 条；已检 <b class="u-text-success">{{ itemSummary.completedCount || 0 }}</b> 条；未检 <b class="u-text-primary">{{ itemSummary.uncompletedCount || 0 }}</b> 条。</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="报告编号"
                  class="c-form__item"
                >
                  <span class="c-form__read u-text-primary">{{ detail.bgbh || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测报告"
                  class="c-form__item"
                >
                  <span class="c-form__read">未生成报告</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                检测建筑物概况
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="竣工日期"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayDate((detail.jzwgk || {}).jgrq) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="建筑总面积（m²）"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayValue((detail.jzwgk || {}).jzmj) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="检测面积（m²）"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayValue((detail.jzwgk || {}).jcmj) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="建筑类别"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ enumText('IFF_JZLB_JC', (detail.jzwgk || {}).jzlb) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="建筑楼层"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ (detail.jzwgk || {}).jzlc || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                class="c-form__col"
              >
                <el-form-item
                  label="建筑高度（m）"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ displayValue((detail.jzwgk || {}).jzgd) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测类型"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ enumText('IFF_JCLX', (detail.jzwgk || {}).jclx) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测范围"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ enumText('IFF_JCFWLX', (detail.jzwgk || {}).jcfw) }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="竣工图纸情况"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ (detail.jzwgk || {}).jgtztgqk || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="使用功能"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ (detail.jzwgk || {}).sygn || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col"
              >
                <el-form-item
                  label="检测部位"
                  class="c-form__item"
                >
                  <span class="c-form__read">{{ (detail.jzwgk || {}).jcbw || '-' }}</span>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col c-form__part-title"
              >
                建筑信息
              </el-col>
            </el-row>
          </el-form>
          <div class="jx-jc-building-wrap">
            <el-table
              height="100%"
              :data="buildingPage.rows"
              border
              stripe
              class="jx-jc-building-table"
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              />
              <el-table-column
                prop="jzwmc"
                label="建筑名称"
                min-width="180"
              />
              <el-table-column
                prop="gd"
                label="高度（m）"
                width="100"
                align="right"
              />
              <el-table-column
                prop="jzmj"
                label="建筑面积（m²）"
                width="125"
                align="right"
              />
              <el-table-column
                prop="jcmj"
                label="检测面积（m²）"
                width="125"
                align="right"
              />
              <el-table-column
                prop="dscs"
                label="地上层层数"
                width="100"
                align="center"
              />
              <el-table-column
                prop="dxcs"
                label="地下层层数"
                width="100"
                align="center"
              />
              <el-table-column
                label="建筑类别"
                min-width="150"
              >
                <template slot-scope="scope">
                  {{ enumText('IFF_JZLB_JC', scope.row.jzlb) }}
                </template>
              </el-table-column>
              <el-table-column
                label="检测类型"
                min-width="110"
              >
                <template slot-scope="scope">
                  {{ enumText('IFF_JCLX', scope.row.jclx) }}
                </template>
              </el-table-column>
              <el-table-column
                label="检测范围"
                min-width="110"
              >
                <template slot-scope="scope">
                  {{ enumText('IFF_JCFWLX', scope.row.jcfw) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="jx-jc-building-pagination">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="buildingPage.pageNo || 1"
                :page-size="buildingPage.pageSize"
                :page-sizes="[15, 30, 50]"
                :total="buildingPage.total"
                @current-change="loadBuildings"
                @size-change="changeBuildingSize"
              />
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane
          label="检测项"
          name="items"
          class="jx-jc-tab-table"
        >
          <div class="jx-jc-result-rule">
            <span class="jx-jc-result-rule__title">判定说明</span>
            <span>检测项：任一检测点不合格即判为不合格；全部检测点均为不存在时判为不存在；存在未填写的明细时判为未检。单个检测项不合格不等同于项目综合结论不合格。</span>
            <span>{{ projectRuleDescription }}</span>
          </div>
          <el-form
            ref="itemFilter"
            :model="itemFilter"
            :inline="true"
            label-position="right"
            label-width="90px"
            label-suffix="："
            class="c-form c-condition__form jx-jc-item-filter"
          >
            <el-row class="c-form__row">
              <el-col
                :span="12"
                class="c-form__col"
              >
                <el-form-item
                  label="检测内容"
                  class="c-form__item"
                >
                  <div class="jx-jc-filter-pair">
                    <el-select
                      v-model="itemFilter.ssxtxh"
                      clearable
                      placeholder="全部设施系统"
                      @change="handleItemSystemChange"
                    >
                      <el-option
                        v-for="item in detail.ssxtList || []"
                        :key="item.ssxtxh"
                        :label="item.ssxtmc"
                        :value="item.ssxtxh"
                      />
                    </el-select><el-select
                      v-model="itemFilter.jcdxh"
                      clearable
                      placeholder="全部检测点"
                    >
                      <el-option
                        v-for="item in pointCategories"
                        :key="item.jcdxh"
                        :label="item.jcdmc"
                        :value="item.jcdxh"
                      />
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                class="c-form__col"
              >
                <el-form-item
                  label="检测结果"
                  class="c-form__item"
                >
                  <el-select
                    v-model="itemFilter.jcjg"
                    clearable
                    placeholder="请选择检测结果"
                  >
                    <el-option
                      label="合格"
                      value="HG"
                    /><el-option
                      label="不合格"
                      value="BHG"
                    /><el-option
                      label="不存在"
                      value="W"
                    /><el-option
                      label="未检"
                      value="WJ"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                class="c-form__col"
              >
                <el-form-item
                  label="检测点与明细数"
                  label-width="120px"
                  class="c-form__item"
                >
                  <el-select
                    v-model="itemFilter.jcdmxs"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      label="相同"
                      value="Y"
                    /><el-option
                      label="不同"
                      value="N"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col jx-jc-filter-actions"
              >
                <k-button
                  btn-text="查询"
                  :auth-type="false"
                  type="primary"
                  icon="kestrel-icon ki-search"
                  @click="loadItems(1)"
                /><k-button
                  btn-text="重置"
                  :auth-type="false"
                  icon="kestrel-icon ki-repeat"
                  @click="resetItemFilter"
                /><span class="u-fl u-text-primary">（已检测：{{ itemSummary.completedCount || 0 }} 、未检测：{{ itemSummary.uncompletedCount || 0 }}）</span>
              </el-col>
            </el-row>
          </el-form>
          <k-table
            height="100%"
            :table-column="itemColumns"
            :data="itemPage.rows"
            :pagination="itemPage"
            @current-change="loadItems"
            @size-change="changeItemSize"
          >
            <template #jcjg="scope">
              <span :class="resultClass(scope.row.jcjg)">{{ scope.row.jcjgMc || conclusionText(scope.row.jcjg) }}</span>
            </template>
          </k-table>
        </el-tab-pane>

        <el-tab-pane
          label="检测点明细"
          name="points"
          class="jx-jc-tab-table"
        >
          <el-form
            ref="pointFilter"
            :model="pointFilter"
            :inline="true"
            label-position="right"
            label-width="85px"
            label-suffix="："
            class="c-form c-condition__form jx-jc-point-filter"
          >
            <el-row class="c-form__row">
              <el-col
                :span="10"
                class="c-form__col"
              >
                <el-form-item
                  label="检测设备"
                  class="c-form__item"
                >
                  <div class="jx-jc-filter-pair">
                    <el-select
                      v-model="pointFilter.ssxtxh"
                      clearable
                      placeholder="请选择系统"
                      @change="handlePointSystemChange"
                    >
                      <el-option
                        v-for="item in detail.ssxtList || []"
                        :key="item.ssxtxh"
                        :label="item.ssxtmc"
                        :value="item.ssxtxh"
                      />
                    </el-select><el-select
                      v-model="pointFilter.jcdxh"
                      clearable
                      placeholder="请选择设备"
                    >
                      <el-option
                        v-for="item in pointCategories"
                        :key="item.jcdxh"
                        :label="item.jcdmc"
                        :value="item.jcdxh"
                      />
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col
                :span="5"
                class="c-form__col"
              >
                <el-form-item
                  label="建筑物"
                  class="c-form__item"
                >
                  <el-select
                    v-model="pointFilter.jzwId"
                    clearable
                    placeholder="请选择建筑物"
                    @change="handleBuildingChange"
                  >
                    <el-option
                      v-for="item in detail.jzwList || []"
                      :key="item.uuid"
                      :label="item.jzwmc"
                      :value="item.uuid"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="4"
                class="c-form__col"
              >
                <el-form-item
                  label="楼层"
                  class="c-form__item"
                >
                  <el-select
                    v-model="pointFilter.lc"
                    clearable
                    placeholder="请选择楼层"
                  >
                    <el-option
                      v-for="floor in floorOptions"
                      :key="floor"
                      :label="floor"
                      :value="floor"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="5"
                class="c-form__col"
              >
                <el-form-item
                  label="检测结果"
                  class="c-form__item"
                >
                  <el-select
                    v-model="pointFilter.jcjg"
                    clearable
                    placeholder="请选择检测结果"
                  >
                    <el-option
                      label="合格"
                      value="HG"
                    /><el-option
                      label="不合格"
                      value="BHG"
                    /><el-option
                      label="不存在"
                      value="W"
                    /><el-option
                      label="未检"
                      value="WJ"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                class="c-form__col jx-jc-filter-actions"
              >
                <k-button
                  btn-text="查询"
                  :auth-type="false"
                  type="primary"
                  icon="kestrel-icon ki-search"
                  @click="loadPoints(1)"
                /><k-button
                  btn-text="重置"
                  :auth-type="false"
                  icon="kestrel-icon ki-repeat"
                  @click="resetPointFilter"
                />
              </el-col>
            </el-row>
          </el-form>
          <k-table
            height="100%"
            :table-column="pointColumns"
            :data="pointPage.rows"
            :pagination="pointPage"
            @current-change="loadPoints"
            @size-change="changePointSize"
          >
            <template #jcdbh="scope">
              <el-link
                type="primary"
                @click="showPointItems(scope.row)"
              >
                {{ scope.row.jcdbh }}
              </el-link>
            </template>
            <template #wcztMc="scope">
              <span :class="scope.row.wczt === 'YJ' ? 'u-text-success' : 'u-text-primary'">{{ scope.row.wcztMc }}</span>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="检测项结果"
        :visible.sync="itemDialogVisible"
        width="76%"
        append-to-body
      >
        <el-table
          v-loading="itemLoading"
          :data="pointItems"
          border
          stripe
          max-height="520"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          />
          <el-table-column
            prop="jxcbh"
            label="检测项编号"
            min-width="145"
          />
          <el-table-column
            prop="jcxmc"
            label="检测项"
            min-width="240"
          />
          <el-table-column
            prop="jbdm"
            label="等级"
            width="65"
            align="center"
          />
          <el-table-column
            prop="jsyq"
            label="技术要求"
            min-width="300"
            show-overflow-tooltip
          />
          <el-table-column
            prop="jcjgMc"
            label="检测结果"
            width="90"
            align="center"
          />
          <el-table-column
            prop="czrMc"
            label="检测人员"
            width="110"
          />
          <el-table-column
            prop="jcsj"
            label="检测时间"
            width="155"
          />
        </el-table>
      </el-dialog>
      <jc-xm-modification-dialog
        v-if="modificationVisible"
        :xm-id="$route.params.xmId"
        @close="modificationVisible = false"
        @success="handleModificationSuccess"
      />
    </div>
  </div>
</template>

<script>
import { projectService } from './project.service.js';
import JcXmModificationDialog from './jcXmModificationDialog.vue';

export default {
  name: 'JxxfJcProjectDetail',
  components: { JcXmModificationDialog },
  data () {
    return {
      loading: false,
      isProjectManager: false,
      conclusionEditing: false,
      conclusionDraft: '',
      modificationVisible: false,
      detail: {},
      buildingPage: { rows: [], total: 0, pageNo: 0, pageSize: 15 },
      buildingLoaded: false,
      activeTab: 'base',
      facilityOptions: [],
      facilityCheckedIds: [],
      pointCategories: [],
      itemLoaded: false,
      pointLoaded: false,
      summaryLoaded: false,
      itemDialogVisible: false,
      itemLoading: false,
      pointItems: [],
      itemSummary: {},
      buildingColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'jzwmc', slotName: 'jzwmc', label: '建筑名称', align: 'left', minWidth: 180, type: 'text' },
        { key: 'gd', label: '高度（m）', align: 'right', width: 100, type: 'text' },
        { key: 'jzmj', label: '建筑面积（m²）', align: 'right', width: 125, type: 'text' },
        { key: 'jcmj', label: '检测面积（m²）', align: 'right', width: 125, type: 'text' },
        { key: 'dscs', label: '地上层层数', align: 'center', width: 100, type: 'text' },
        { key: 'dxcs', label: '地下层层数', align: 'center', width: 100, type: 'text' },
        { key: 'jzlb', slotName: 'jzlb', label: '建筑类别', align: 'left', minWidth: 150, type: 'text' },
        { key: 'jclx', slotName: 'jclx', label: '检测类型', align: 'left', minWidth: 110, type: 'text' },
        { key: 'jcfw', slotName: 'jcfw', label: '检测范围', align: 'left', minWidth: 110, type: 'text' }
      ],
      itemFilter: { ssxtxh: null, jcdxh: null, jcjg: null, jcdmxs: null },
      itemPage: { rows: [], total: 0, pageNo: 0, pageSize: 15 },
      itemColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'jxcbh', label: '编号', align: 'left', width: 90, type: 'text' },
        { key: 'jcxmc', label: '检测项', align: 'left', minWidth: 180, type: 'text' },
        { key: 'jsyq', label: '检测标准（规范要求）', align: 'left', minWidth: 260, type: 'text' },
        { key: 'jbdm', label: '重要等级', align: 'center', width: 80, type: 'text' },
        { key: 'jcds', label: '检测点数', align: 'center', width: 90, type: 'text' },
        { key: 'bhgds', label: '不合格点数', align: 'center', width: 100, type: 'text' },
        { key: 'mxsl', label: '明细数量', align: 'center', width: 90, type: 'text' },
        { key: 'jcjg', slotName: 'jcjg', label: '检测结果', align: 'center', width: 90, type: 'text' },
        { key: 'bz', label: '备注', align: 'left', minWidth: 120, type: 'text' }
      ],
      pointFilter: { ssxtxh: null, jcdxh: null, jzwId: null, lc: null, jcjg: null },
      pointPage: { rows: [], total: 0, pageNo: 0, pageSize: 15 },
      pointColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'jcdbh', slotName: 'jcdbh', label: '检测点编号', align: 'left', width: 110, type: 'text' },
        { key: 'jcdmc', label: '设备名称', align: 'left', minWidth: 180, type: 'text' },
        { key: 'jzwmc', label: '建筑或防火分区', align: 'left', minWidth: 180, type: 'text' },
        { key: 'lc', label: '楼层', align: 'center', width: 80, type: 'text' },
        { key: 'jcdsl', label: '数量', align: 'center', width: 70, type: 'text' },
        { key: 'bz', label: '备注信息', align: 'left', minWidth: 160, type: 'text' },
        { key: 'wcztMc', slotName: 'wcztMc', label: '检测项完成状态', align: 'center', width: 120, type: 'text' },
        { key: 'createTime', label: '录入时间', align: 'center', width: 150, type: 'dateTime' }
      ]
    };
  },
  computed: {
    canApplyModification () {
      return this.isProjectManager && this.detail.xmzt === 'DGZ';
    },
    canEditConclusion () {
      return this.isProjectManager && this.detail.xmzt === 'DSC';
    },
    projectRuleDescription () {
      const values = [this.detail.azds, this.detail.bzds, this.detail.czds, this.detail.bchjzds];
      if (values.some(value => value === null || value === undefined)) {
        return '项目综合判定：按该项目当前范围版本固化的 A/B/C 判定规则计算。';
      }
      const version = this.detail.gzbbh ? `（规则版本 ${this.detail.gzbbh}）` : '';
      return `项目综合判定${version}：A 类不合格项不超过 ${this.detail.azds} 项；B 类不超过 ${this.detail.bzds} 项；C 类不超过 ${this.detail.czds} 项；B、C 类合计不超过 ${this.detail.bchjzds} 项，全部满足时项目综合结论为合格。`;
    },
    facilityNames () {
      const values = this.detail.ssxtList || [];
      return values.length ? values.map(item => `${item.ssxtbh || ''} ${item.ssxtmc || ''}`.trim()).join('；') : '-';
    },
    floorOptions () {
      const building = (this.detail.jzwList || []).find(item => item.uuid === this.pointFilter.jzwId);
      if (!building) return [];
      const result = [];
      for (let floor = -(building.dxcs || 0); floor <= (building.dscs || 0); floor++) {
        if (floor !== 0) result.push(`${floor}F`);
      }
      return result;
    }
  },
  methods: {
    displayDate (value) {
      if (!value) return '-';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
      const pad = number => (`0${number}`).slice(-2);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    },
    displayValue (value) {
      return value === null || value === undefined || value === '' ? '-' : value;
    },
    enumText (groupKey, value) {
      const options = (this.$store.state.apiEnums.iffApi || {})[groupKey] || {};
      if (Array.isArray(options)) {
        const matched = options.find(item => String(item.id) === String(value));
        return matched ? matched.text : (value || '-');
      }
      const option = options[`ENUM_KEY_${value}`];
      return option ? option.text : (value || '-');
    },
    memberNames (type) {
      const values = (this.detail.ryList || []).filter(item => item.ryLx === type).map(item => item.ryMc).filter(Boolean);
      return values.length ? values.join('、') : '-';
    },
    conclusionText (value) {
      if (value === 'Y' || value === 'HG') return '合格';
      if (value === 'N' || value === 'BHG') return '不合格';
      if (value === 'W') return '不存在';
      return '/';
    },
    resultClass (value) {
      if (value === 'HG') return 'u-text-success';
      if (value === 'BHG') return 'u-text-danger';
      return 'u-text-primary';
    },
    loadFacilities () {
      projectService.facilities().then(rsp => { this.facilityOptions = rsp.data || []; });
    },
    downloadContract () {
      const fileId = this.detail.htfjid;
      if (!fileId) return;
      this.$axios.get(`${this.$config.fileApi.initDownload}/${fileId}`).then(rsp => {
        const path = rsp.data && rsp.data.data;
        if (!path) throw new Error('合同文件路径为空');
        return this.$axios.get(`${this.$config.fileApi.download}/${path}`, { responseType: 'blob' });
      }).then(res => {
        const disposition = res.headers && res.headers['content-disposition'];
        const matched = disposition && disposition.split('=')[1];
        const fileName = matched ? decodeURIComponent(matched.replace(/^"|"$/g, '')) : '合同文件';
        this.$HMUtil.downloadStreamFile(res.data, fileName);
      }).catch(() => this.$message.error('合同文件下载失败'));
    },
    handleTab (tab) {
      if (tab.name === 'plan') {
        this.loadItemSummary();
        if (!this.buildingLoaded) this.loadBuildings();
      }
      if (tab.name === 'items') {
        if (!this.itemLoaded) {
          this.loadPointCategoriesFor(this.itemFilter.ssxtxh);
          this.loadItems(1);
        }
        this.loadItemSummary();
      }
      if (tab.name === 'points' && !this.pointLoaded) {
        this.loadPointCategoriesFor(this.pointFilter.ssxtxh);
        this.loadPoints(1);
      }
    },
    handleItemSystemChange () {
      this.itemFilter.jcdxh = null;
      this.loadPointCategoriesFor(this.itemFilter.ssxtxh);
    },
    handlePointSystemChange () {
      this.pointFilter.jcdxh = null;
      this.loadPointCategoriesFor(this.pointFilter.ssxtxh);
    },
    loadPointCategoriesFor (systemId) {
      projectService.pointCategories(this.$route.params.xmId, { ssxtxh: systemId || null })
        .then(rsp => { this.pointCategories = rsp.data || []; });
    },
    loadItemSummary () {
      projectService.itemSummary(this.$route.params.xmId)
        .then(rsp => { this.itemSummary = rsp.data || {}; this.summaryLoaded = true; });
    },
    loadItems (pageNo = 1) {
      this.loading = true;
      projectService.items(this.$route.params.xmId, Object.assign({}, this.itemFilter, { pageNo, pageSize: this.itemPage.pageSize }))
        .then(rsp => { this.itemPage = Object.assign({}, this.itemPage, rsp.data); this.itemLoaded = true; })
        .finally(() => { this.loading = false; });
    },
    resetItemFilter () {
      this.$refs.itemFilter.resetFields();
      this.loadPointCategoriesFor(null);
      this.loadItems(1);
    },
    changeItemSize (size) {
      this.itemPage.pageSize = size;
      this.loadItems(1);
    },
    handleBuildingChange () {
      this.pointFilter.lc = null;
    },
    loadPoints (pageNo = 1) {
      this.loading = true;
      projectService.points(this.$route.params.xmId, Object.assign({}, this.pointFilter, { pageNo, pageSize: this.pointPage.pageSize }))
        .then(rsp => { this.pointPage = Object.assign({}, this.pointPage, rsp.data); this.pointLoaded = true; })
        .finally(() => { this.loading = false; });
    },
    resetPointFilter () {
      this.$refs.pointFilter.resetFields();
      this.loadPointCategoriesFor(null);
      this.loadPoints(1);
    },
    changePointSize (size) {
      this.pointPage.pageSize = size;
      this.loadPoints(1);
    },
    showPointItems (row) {
      this.itemDialogVisible = true;
      this.itemLoading = true;
      this.pointItems = [];
      projectService.pointItems(this.$route.params.xmId, row.uuid)
        .then(rsp => { this.pointItems = rsp.data || []; })
        .finally(() => { this.itemLoading = false; });
    },
    loadDetail () {
      this.loading = true;
      projectService.detail(this.$route.params.xmId).then(rsp => {
        this.detail = rsp.data || {};
        if (this.buildingPage.rows.length) this.$set(this.detail, 'jzwList', this.buildingPage.rows);
        this.facilityCheckedIds = (this.detail.ssxtList || []).map(item => item.ssxtxh);
      })
        .finally(() => { this.loading = false; });
    },
    editConclusion () {
      this.conclusionDraft = this.detail.jcjlsm || '';
      this.conclusionEditing = true;
    },
    cancelConclusion () {
      this.conclusionEditing = false;
      this.conclusionDraft = '';
    },
    saveConclusion () {
      if (this.conclusionDraft && !this.conclusionDraft.trim()) {
        this.$message.warning('检测结论说明不能全为空格');
        return;
      }
      this.loading = true;
      projectService.saveConclusion(this.$route.params.xmId, { jcjlsm: this.conclusionDraft })
        .then(() => {
          this.$set(this.detail, 'jcjlsm', this.conclusionDraft ? this.conclusionDraft.trim() : '');
          this.conclusionEditing = false;
          this.$message.success('检测结论说明保存成功');
        })
        .finally(() => { this.loading = false; });
    },
    loadBuildings (pageNo = 1) {
      projectService.buildings(this.$route.params.xmId, { pageNo, pageSize: this.buildingPage.pageSize }).then(rsp => {
        this.buildingPage = Object.assign({}, this.buildingPage, rsp.data || {});
        this.buildingLoaded = true;
        // 同步详情中的建筑物，保证检测点筛选仍能使用建筑物选项。
        this.$set(this.detail, 'jzwList', this.buildingPage.rows);
      });
    },
    changeBuildingSize (size) {
      this.buildingPage.pageSize = size;
      this.loadBuildings(1);
    },
    handleModificationSuccess () {
      this.itemLoaded = false;
      this.pointLoaded = false;
      this.summaryLoaded = false;
      this.itemPage.rows = [];
      this.pointPage.rows = [];
      this.loadDetail();
      this.loadItemSummary();
    }
  },
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.loadFacilities();
    this.loadDetail();
  },
  activated () { this.loadItemSummary(); }
};
</script>

<style lang="scss" scoped>
.jx-jc-read-form .c-form__part-title { margin-top: 4px; }
.jx-jc-multiline { white-space: pre-wrap; line-height: 22px; }
.jx-jc-conclusion-actions { margin-top: 4px; text-align: right; }
.jx-jc-result-rule {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 18px;
  align-items: baseline;
  margin: 0 12px 8px;
  padding: 7px 10px;
  color: #52616b;
  font-size: 13px;
  line-height: 20px;
  background: #f5f8fa;
  border-left: 3px solid #409eff;
}
.jx-jc-result-rule__title { color: #303133; font-weight: 600; }
.jx-jc-filter-pair { display: flex; gap: 8px; width: 100%; }
.jx-jc-filter-pair .el-select { flex: 1; min-width: 0; }
.jx-jc-filter-actions { text-align: right; padding-right: 12px; }
.jx-jc-filter-actions .u-fl { float: left; margin-top: 10px; }
.jx-jc-item-filter, .jx-jc-point-filter { padding-bottom: 4px; }
// tab-pane 已是定高，筛选表单与表格需分摊高度，否则 k-table 的 100% 会把内容顶出容器产生外层滚动条。
.jx-jc-tab-table {
  display: flex;
  flex-direction: column;

  ::v-deep .c-page__pTable { flex: 1; min-height: 0; height: auto; }
}
.jx-jc-tab-table > .c-form { flex-shrink: 0; }
.jx-jc-plan-form .el-table { width: 100%; }
.jx-jc-tab-plan {
  display: flex;
  flex-direction: column;

  .jx-jc-plan-form { flex-shrink: 0; }
}
.jx-jc-building-wrap {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}
.jx-jc-building-wrap .jx-jc-building-table { flex: 1; min-height: 0; }
.jx-jc-building-pagination { flex-shrink: 0; text-align: right; padding: 2px 58px 0px 4px; }
.jx-jc-facility-checks { display: flex; flex-wrap: wrap; gap: 4px 18px; }
.jx-jc-facility-checks .el-checkbox { margin-right: 0; }
</style>
